import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import en from './locales/en.json';
import es from './locales/es.json';

export const PUBLIC_SURVEY_LANG_KEY = 'fixe-public-survey-lang';
export const PUBLIC_SURVEY_NAMESPACE = 'publicSurvey';

export const PUBLIC_SURVEY_LANGUAGES = ['pt-BR', 'pt-PT', 'en', 'es'] as const;
export type PublicSurveyLanguage = (typeof PUBLIC_SURVEY_LANGUAGES)[number];

export function isPublicSurveyLanguage(value: string): value is PublicSurveyLanguage {
  return (PUBLIC_SURVEY_LANGUAGES as readonly string[]).includes(value);
}

/** Normaliza códigos de idioma do browser/URL para os suportados. */
export function normalizePublicSurveyLanguage(value: string | null | undefined): PublicSurveyLanguage {
  if (!value) return 'pt-BR';
  const lower = value.toLowerCase();
  if (lower === 'pt-br' || lower === 'pt_br') return 'pt-BR';
  if (lower === 'pt-pt' || lower === 'pt_pt' || lower === 'pt') return 'pt-PT';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('es')) return 'es';
  if (isPublicSurveyLanguage(value)) return value;
  return 'pt-BR';
}

export const publicSurveyI18n = i18n.createInstance();

publicSurveyI18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { [PUBLIC_SURVEY_NAMESPACE]: ptBR },
      'pt-PT': { [PUBLIC_SURVEY_NAMESPACE]: ptPT },
      en: { [PUBLIC_SURVEY_NAMESPACE]: en },
      es: { [PUBLIC_SURVEY_NAMESPACE]: es },
    },
    ns: [PUBLIC_SURVEY_NAMESPACE],
    defaultNS: PUBLIC_SURVEY_NAMESPACE,
    fallbackLng: 'pt-BR',
    supportedLngs: [...PUBLIC_SURVEY_LANGUAGES],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: PUBLIC_SURVEY_LANG_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => normalizePublicSurveyLanguage(lng),
    },
    react: { useSuspense: false },
  });

export function syncDocumentLanguage(lng: string) {
  document.documentElement.lang = lng;
}
